// shared/ui/AsistenteCard.jsx  (presentacional: tarjeta de asistente; botón de quitar opcional)
import React, { useEffect, useState } from 'react';
import { colorAvatar, etiquetaParcelas, iniciales } from '../domain/productor';

// `detalle` (opcional): texto extra en la línea de parcelas, p. ej. "3 parcelas · Localidad".
// `fotoUrl` (opcional): foto del productor; si no carga, se vuelve a las iniciales.
const AsistenteCard = ({ asistente, onRemove, detalle, fotoUrl, disabled = false, fullWidth = false }) => {
  const { background, color } = colorAvatar(asistente.id);
  const [fallida, setFallida] = useState(false);
  useEffect(() => setFallida(false), [fotoUrl]);
  const mostrarFoto = !!fotoUrl && !fallida;
  return (
    <div
      className="d-flex align-items-center"
      style={{
        gap: 10,
        border: '1px solid #e2e5ea',
        borderRadius: 12,
        padding: '8px 12px',
        background: '#fff',
        minWidth: fullWidth ? 0 : 240,
        breakInside: 'avoid',
      }}>
      {mostrarFoto ? (
        <img
          src={fotoUrl}
          alt={asistente.nombre}
          onError={() => setFallida(true)}
          style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, background }}
        />
      ) : (
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background,
            color,
            fontWeight: 600,
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}>
          {iniciales(asistente.nombre)}
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 13 }}>{asistente.nombre}</div>
        <div style={{ fontSize: 12, color: '#6c757d' }}>
          {[etiquetaParcelas(asistente.total_parcelas), detalle].filter(Boolean).join(' · ')}
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          className="btn btn-link p-0"
          style={{ color: '#6c757d', fontSize: 20, lineHeight: 1 }}
          aria-label={`Quitar a ${asistente.nombre}`}
          disabled={disabled}
          onClick={() => onRemove(asistente.id)}>
          ×
        </button>
      )}
    </div>
  );
};

export default AsistenteCard;
